import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import CancelIcon from '@mui/icons-material/Cancel';
import { grey, lightGreen } from '@mui/material/colors';
import { useWatch } from 'react-hook-form';

interface Props {
  fieldId: string;
}

export const MappingStatusIcon = ({ fieldId }: Props) => {
  const mappedValue = useWatch({
    name: `mappingsByLenderFieldId.${fieldId}.mappedValue`,
  });

  const isMapped = !!mappedValue || mappedValue === 0;

  return (
    <>
      {isMapped ? (
        <>
          <CheckCircleIcon sx={{ color: lightGreen[500] }} />
          <ArrowRightAltIcon sx={{ color: lightGreen[500] }} />
        </>
      ) : (
        <>
          <CancelIcon sx={{ color: grey[400] }} />
          <ArrowRightAltIcon sx={{ color: grey[400] }} />
        </>
      )}
    </>
  );
};
